import classes from './CreateAccount.module.scss';

import {
  useActiveAccountContext,
  coerceToInvite,
} from '@/true-fsd/data/advertiser-account';
import { ReactNode, useCallback } from 'react';
import {
  CreateAccountComplete,
  type CreateAccountCompleteProps,
} from './CreateAccountComplete';
import { useLocation } from 'react-router';

type RenderLayoutProps = {
  slotHeader: ReactNode;
  slotTitle: ReactNode;
  slotButtons: ReactNode;
  slotBottom: ReactNode;

  children: ReactNode;
};

export type CreateAccountCompleteActiveProps = {
  RenderLayout: (p: RenderLayoutProps) => ReactNode;
};
export const CreateAccountCompleteActive = ({
  RenderLayout,
}: CreateAccountCompleteActiveProps) => {
  const { activeAccount } = useActiveAccountContext();
  const location = useLocation();

  const RenderLayoutWithBottom: CreateAccountCompleteProps['RenderLayout'] =
    useCallback(
      (props) => {
        return (
          <RenderLayout
            {...props}
            slotBottom={
              <div className={classes.bottomText}>
                Завершая регистрацию вы соглашаетесь с условиями договора-оферты
              </div>
            }
          />
        );
      },
      [RenderLayout],
    );

  return (
    <CreateAccountComplete
      RenderLayout={RenderLayoutWithBottom}
      account={activeAccount}
      invite={coerceToInvite(location.state, undefined)}
    />
  );
};
